import ButtonDivider from "../../../components/ButtonDivider";
import styles from "./Admin.module.css";
import { useEffect, useState } from "react";

function Card({ billboard, user, onStatusUpdate }) {
  const [showingMore, setShowingMore] = useState(false);
  const [notes, setNotes] = useState("");
  const [status, setStatus] = useState(billboard.status);
  const [message, setMessage] = useState(null); // { type: 'success' | 'error', text: string }
  const [loading, setLoading] = useState(false);

  const postDecision = async ({ newStatus, notes }) => {
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(
        "https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/billboard-decision",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwt}`,
          },
          body: JSON.stringify({
            id: billboard.id,
            steamId: billboard.steamId,
            newStatus,
            notes,
            spent: billboard.spent,
            months: billboard.months,
          }),
        }
      );

      if (!res.ok) {
        const errorText = await res.text();
        setMessage({ type: "error", text: `❌ ${errorText}` });
      } else {
        setStatus(newStatus);
        setMessage({
          type: "success",
          text: `✅ Billboard marked as ${newStatus}`,
        });
        onStatusUpdate(billboard.id, newStatus, notes);
      }
    } catch (err) {
      setMessage({ type: "error", text: `❌ ${err.message}` });
    }

    setLoading(false);
  };

  return (
    <div
      className={`${styles.myBillboard} ${
        styles[`myBillboard${status.replace(" ", "")}`]
      }`}
    >
      <div className={styles.imageBox}>
        <img src={billboard.s3Url} alt="Billboard" />
      </div>

      <div className={styles.right}>
        <div className={styles.header}>
          <a
            href={`http://steamcommunity.com/profiles/${billboard.steamId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {billboard.steamId}
          </a>
          <div>
            {new Date(billboard.createdAt).toLocaleDateString()}{" "}
            {status === "ACTIVE" || status === "EXPIRED"
              ? " - " + new Date(billboard.expiresAt).toLocaleDateString()
              : ""}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.monthsAndTokens}>
            <p>
              {billboard.months} month{billboard.months > 1 ? "s" : ""}
            </p>
            {billboard.status === "REJECTED" ? (
              <s>🪙{billboard.spent}</s>
            ) : (
              <>🪙{billboard.spent}</>
            )}
            {billboard.status === "REJECTED" ? " (REFUNDED)" : ""}
          </div>
          {billboard.status === "ACTIVE" ? (
            new Date(billboard.expiresAt) < new Date() ? (
              <p className={styles.pastExpireDate}>PAST EXPIRE DATE</p>
            ) : (
              <p className={styles.timeRemaining}>
                {Math.ceil(
                  (new Date(billboard.expiresAt) - new Date()) /
                    (1000 * 60 * 60 * 24)
                )}{" "}
                days remaining
              </p>
            )
          ) : (
            <></>
          )}

          <div
            className={`${styles.status} ${
              styles[`status${status.replace(" ", "")}`]
            }`}
          >
            {status}
          </div>
        </div>

        {status === "PENDING APPROVAL" && (
          <div className={styles.decisionBox}>
            <textarea
              className={styles.textArea}
              placeholder="Decision notes..."
              onChange={(e) => setNotes(e.target.value)}
            />
            <div className={styles.buttonsContainer}>
              <button
                className={`${styles.approveButton} ${
                  loading ? styles.disabledButton : ""
                }`}
                onClick={() => postDecision({ newStatus: "ACTIVE", notes })}
                disabled={loading}
              >
                {loading ? "..." : "APPROVE"}
              </button>
              <button
                className={`${styles.rejectButton} ${
                  loading ? styles.disabledButton : ""
                }`}
                onClick={() => postDecision({ newStatus: "REJECTED", notes })}
                disabled={loading}
              >
                {loading ? "..." : "REJECT"}
              </button>
            </div>
          </div>
        )}

        {message && (
          <div
            style={{
              marginTop: 8,
              padding: "6px 10px",
              color: "#fff",
              backgroundColor: message.type === "error" ? "#8b0000" : "#155724",
              borderLeft: `4px solid ${
                message.type === "error" ? "#f44336" : "#4caf50"
              }`,
            }}
          >
            {message.text}
          </div>
        )}

        {showingMore ? (
          <>
            <div className={styles.detailsBox}>
              <div className={styles.timeRow}>
                <span>ID:</span>
                <span>{billboard.id}</span>
              </div>
              <div className={styles.timeRow}>
                <span>s3Key:</span>
                <span>{billboard.s3Key}</span>
              </div>
              <div className={styles.timeRow}>
                <span>s3Url:</span>
                <span>{billboard.s3Url}</span>
              </div>
              {billboard.notes && (
                <div className={styles.timeRow}>
                  <span>notes:</span>
                  <span>{billboard.notes}</span>
                </div>
              )}
            </div>
            <button
              className={styles.showingMoreButton}
              onClick={() => setShowingMore(false)}
            >
              Less details
            </button>
          </>
        ) : (
          <button
            className={styles.showingMoreButton}
            onClick={() => setShowingMore(true)}
          >
            More details
          </button>
        )}
      </div>
    </div>
  );
}

function Admin({ user }) {
  const [allBillboards, setAllBillboards] = useState([]);
  const [updateResult, setUpdateResult] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(null);

  useEffect(() => {
    if (!user) {
      return;
    } else if (!user.adminUi) {
      window.location.href = "/billboards";
      return;
    }
    const fetchAllBillboards = async () => {
      const res = await fetch(
        "https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/get-all-billboards",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.jwt}`,
          },
        }
      );
      if (res.ok) {
        const data = await res.json();
        setAllBillboards(
          data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
        );
      } else if (res.status === 401 || res.status === 403) {
        //navigate("/billboards");
      }
    };
    fetchAllBillboards();
  }, [user]);

  const updateBillboardStatus = (id, newStatus, newNotes) => {
    setAllBillboards((prev) =>
      prev.map((b) =>
        b.id === id ? { ...b, status: newStatus, notes: newNotes } : b
      )
    );
  };

  const pending = allBillboards.filter((b) => b.status === "PENDING APPROVAL");
  const active = allBillboards.filter((b) => b.status === "ACTIVE");
  const others = allBillboards.filter(
    (b) => b.status !== "PENDING APPROVAL" && b.status !== "ACTIVE"
  );

  if (user) {
    return (
      <div className={styles.admin}>
        <div className={styles.panel}>
          <ButtonDivider text={"PENDING APPROVAL"} />
          {pending.length > 0 ? (
            pending.map((b) => (
              <Card
                key={b.id}
                billboard={b}
                user={user}
                onStatusUpdate={updateBillboardStatus}
              />
            ))
          ) : (
            <p className={styles.emptyNotice}>
              0 billboards "PENDING APPROVAL"
            </p>
          )}
          <ButtonDivider text={"UPDATE STATE"} />
          <button
            className={styles.uploadStateButton}
            onClick={() => {
              setUpdateResult(null);
              setUpdateLoading(true);
              const updateBillboardState = async () => {
                try {
                  const res = await fetch(
                    "https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/update-billboard-state",
                    {
                      method: "GET",
                      headers: {
                        Authorization: `Bearer ${user.jwt}`,
                      },
                    }
                  );
                  if (res.ok) {
                    const data = await res.text();
                    setUpdateResult({ type: "success", text: `✅ ${data}` });
                  } else {
                    const errorText = await res.text();
                    setUpdateResult({ type: "error", text: `❌ ${errorText}` });
                  }
                } catch (err) {
                  setUpdateResult({ type: "error", text: `❌ ${err.message}` });
                } finally {
                  setUpdateLoading(false);
                }
              };
              updateBillboardState();
            }}
            disabled={updateLoading}
          >
            {updateLoading ? "UPDATING..." : "UPDATE BILLBOARD STATE"}
          </button>

          {updateResult && (
            <div
              className={styles.updateResult}
              style={{
                borderLeftColor:
                  updateResult.type === "error" ? "#cc0000" : "#4caf50",
              }}
            >
              {updateResult.text}
            </div>
          )}
        </div>
        <div className={styles.panel}>
          <ButtonDivider text={"ACTIVE BILLBOARDS"} />
          {active.length > 0 ? (
            active.map((b) => (
              <Card
                key={b.id}
                billboard={b}
                user={user}
                onStatusUpdate={updateBillboardStatus}
              />
            ))
          ) : (
            <p className={styles.emptyNotice}>0 "ACTIVE" billboards</p>
          )}
          <ButtonDivider text={"REJECTED/EXPIRED"} />
          {others.length > 0 ? (
            others.map((b) => (
              <Card
                key={b.id}
                billboard={b}
                user={user}
                onStatusUpdate={updateBillboardStatus}
              />
            ))
          ) : (
            <p className={styles.emptyNotice}>
              0 "REJECTED" or "EXPIRED" billboards
            </p>
          )}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}

export default Admin;
